/* ============================================
   QN-NEW HEADER JS
   ============================================ */

(function () {
  'use strict';

  const QNHeader = {
    init() {
      this.cacheElements();
      this.bindEvents();
      this.searchAbortController = null;
      this.searchDebounce = null;
      this.currentQuery = '';
    },

    cacheElements() {
      this.searchInput = document.querySelector('[data-search-input]');
      this.searchResults = document.querySelector('[data-search-results]');
      this.searchForm = this.searchInput ? this.searchInput.closest('form') : null;
      this.categoriesBtn = document.querySelector('[data-categories-trigger]');
      this.cartBtn = document.querySelector('[data-cart-trigger]');
      this.mobileMenuBtn = document.querySelector('[data-mobile-menu-trigger]');
    },

    bindEvents() {
      if (this.categoriesBtn) {
        this.categoriesBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleCategoriesDrawer();
        });
      }

      if (this.mobileMenuBtn) {
        this.mobileMenuBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.openCategoriesDrawer();
        });
      }

      document.addEventListener('qn:categ-drawer:close', () => {
        if (this.categoriesBtn) {
          this.categoriesBtn.setAttribute('aria-expanded', 'false');
        }
      });

      if (this.cartBtn) {
        this.cartBtn.addEventListener('click', (e) => {
          e.preventDefault();
          document.dispatchEvent(new CustomEvent('qn:cart:open'));
        });
      }

      if (this.searchInput && this.searchResults) {
        this.searchInput.addEventListener('input', this.handleSearchInput.bind(this));
        this.searchInput.addEventListener('focus', this.handleSearchFocus.bind(this));
        this.searchInput.addEventListener('keydown', this.handleSearchKeydown.bind(this));
      }

      document.addEventListener('click', (e) => {
        if (this.searchResults && !e.target.closest('.qn-header__search')) {
          this.closeSearch();
        }
      });
    },

    openCategoriesDrawer() {
      if (window.QNCategDrawer && typeof window.QNCategDrawer.open === 'function') {
        window.QNCategDrawer.open();
        if (this.categoriesBtn) {
          this.categoriesBtn.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      document.dispatchEvent(new CustomEvent('qn:categ-drawer:open'));

      const drawer = document.querySelector('.qn-categ-drawer');
      const overlay = document.querySelector('.qn-categ-drawer__overlay');

      if (drawer) {
        drawer.classList.add('active');
        drawer.setAttribute('aria-hidden', 'false');
      }

      if (overlay) {
        overlay.classList.add('active');
      }

      document.body.classList.add('overflow-hidden');

      if (this.categoriesBtn) {
        this.categoriesBtn.setAttribute('aria-expanded', 'true');
      }
    },

    closeCategoriesDrawer() {
      if (window.QNCategDrawer && typeof window.QNCategDrawer.close === 'function') {
        window.QNCategDrawer.close();
        return;
      }

      const drawer = document.querySelector('.qn-categ-drawer');
      const overlay = document.querySelector('.qn-categ-drawer__overlay');

      if (drawer) {
        drawer.classList.remove('active');
        drawer.setAttribute('aria-hidden', 'true');
      }

      if (overlay) {
        overlay.classList.remove('active');
      }

      document.body.classList.remove('overflow-hidden');

      if (this.categoriesBtn) {
        this.categoriesBtn.setAttribute('aria-expanded', 'false');
      }
    },

    toggleCategoriesDrawer() {
      const isOpen = this.categoriesBtn && this.categoriesBtn.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.closeCategoriesDrawer();
      } else {
        this.openCategoriesDrawer();
      }
    },

    handleSearchFocus() {
      const value = this.searchInput.value.trim();
      if (value.length >= 2 && this.searchResults.innerHTML.trim() !== '') {
        this.openSearch();
      }
    },

    handleSearchInput(e) {
      const query = e.target.value.trim();
      this.currentQuery = query;

      clearTimeout(this.searchDebounce);

      if (query.length < 2) {
        this.abortSearchRequest();
        this.renderEmptyState();
        this.closeSearch();
        return;
      }

      this.searchDebounce = setTimeout(() => {
        this.fetchPredictiveSearch(query);
      }, 180);
    },

    handleSearchKeydown(e) {
      if (e.key === 'Escape') {
        this.closeSearch();
        this.searchInput.blur();
      }
    },

    abortSearchRequest() {
      if (this.searchAbortController) {
        this.searchAbortController.abort();
        this.searchAbortController = null;
      }
    },

    async fetchPredictiveSearch(query) {
      this.abortSearchRequest();
      this.searchAbortController = new AbortController();

      this.renderLoading();
      this.openSearch();

      try {
        const root =
          window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';

        const url =
          `${root}search/suggest.json?q=${encodeURIComponent(query)}` +
          `&resources[type]=product,collection,page,article,query` +
          `&resources[limit]=8` +
          `&resources[limit_scope]=each`;

        const response = await fetch(url, {
          signal: this.searchAbortController.signal,
          headers: {
            Accept: 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Predictive search error: ${response.status}`);
        }

        const data = await response.json();

        if (this.currentQuery !== query) return;

        this.renderPredictiveResults(data, query, root);
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.renderErrorState();
      }
    },

    renderLoading() {
      if (!this.searchResults) return;

      this.searchResults.innerHTML = `
        <div class="qn-search-state" style="padding: 16px 18px; color: #4b5563;">
          Buscando...
        </div>
      `;
    },

    renderEmptyState() {
      if (!this.searchResults) return;
      this.searchResults.innerHTML = '';
    },

    renderErrorState() {
      if (!this.searchResults) return;

      this.searchResults.innerHTML = `
        <div class="qn-search-state" style="padding: 16px 18px; color: #4b5563;">
          No se pudo cargar la búsqueda.
        </div>
      `;
      this.openSearch();
    },

    renderPredictiveResults(data, query, root) {
      if (!this.searchResults) return;

      const resources = data && data.resources ? data.resources : {};
      const results = resources.results || {};

      const products = Array.isArray(results.products) ? results.products : [];
      const collections = Array.isArray(results.collections) ? results.collections : [];
      const pages = Array.isArray(results.pages) ? results.pages : [];
      const articles = Array.isArray(results.articles) ? results.articles : [];
      const queries = Array.isArray(results.queries) ? results.queries : [];

      const hasResults =
        products.length || collections.length || pages.length || articles.length || queries.length;

      if (!hasResults) {
        this.searchResults.innerHTML = `
          <div class="qn-search-state" style="padding: 16px 18px; color: #4b5563;">
            Sin resultados para “${this.escapeHtml(query)}”.
          </div>
        `;
        this.openSearch();
        return;
      }

      let html = `<div class="qn-search-dropdown" style="padding: 10px 0;">`;

      if (queries.length) {
        html += `
          <div class="qn-search-group">
            <div style="padding: 8px 18px 6px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #6b7280;">
              Sugerencias
            </div>
            ${queries
              .slice(0, 4)
              .map((item) => {
                const text = item.text || '';
                return `
                  <a
                    href="${root}search?q=${encodeURIComponent(text)}"
                    class="qn-search-item"
                    style="display:flex; align-items:center; gap:12px; padding:10px 18px; text-decoration:none; color:#1f2937;"
                  >
                    <span style="display:inline-flex; width:18px; height:18px; align-items:center; justify-content:center; color:#6b7280;">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                        <circle cx="11" cy="11" r="8"></circle>
                        <path d="m21 21-4.35-4.35"></path>
                      </svg>
                    </span>
                    <span>${this.escapeHtml(text)}</span>
                  </a>
                `;
              })
              .join('')}
          </div>
        `;
      }

      if (products.length) {
        html += `
          <div class="qn-search-group">
            <div style="padding: 10px 18px 6px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #6b7280;">
              Productos
            </div>
            ${products
              .slice(0, 4)
              .map((product) => {
                const image = product.featured_image?.url || product.image || '';
                const rawPrice =
                  typeof product.price_min !== 'undefined'
                    ? product.price_min
                    : typeof product.price !== 'undefined'
                      ? product.price
                      : '';
                const price = rawPrice !== '' ? this.formatMoney(rawPrice) : '';
                const title = product.title || '';
                const url = product.url || '#';

                return `
                  <a
                    href="${url}"
                    class="qn-search-item"
                    style="display:flex; align-items:center; gap:12px; padding:10px 18px; text-decoration:none; color:#1f2937;"
                  >
                    <span style="width:52px; height:52px; border-radius:10px; overflow:hidden; flex-shrink:0; background:#f3f4f6; display:flex; align-items:center; justify-content:center;">
                      ${
                        image
                          ? `<img src="${image}" alt="${this.escapeHtml(title)}" style="width:100%; height:100%; object-fit:cover;">`
                          : `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" aria-hidden="true"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>`
                      }
                    </span>
                    <span style="min-width:0; display:flex; flex-direction:column; gap:4px;">
                      <span style="font-size:14px; font-weight:600; line-height:1.25;">${this.escapeHtml(title)}</span>
                      ${price ? `<span style="font-size:13px; color:#2d5a3d; font-weight:700;">${price}</span>` : ''}
                    </span>
                  </a>
                `;
              })
              .join('')}
          </div>
        `;
      }

      if (collections.length) {
        html += `
          <div class="qn-search-group">
            <div style="padding: 10px 18px 6px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #6b7280;">
              Colecciones
            </div>
            ${collections
              .slice(0, 3)
              .map((item) => `
                <a
                  href="${item.url || '#'}"
                  class="qn-search-item"
                  style="display:flex; align-items:center; gap:12px; padding:10px 18px; text-decoration:none; color:#1f2937;"
                >
                  <span style="display:inline-flex; width:18px; height:18px; align-items:center; justify-content:center; color:#6b7280;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <path d="M3 7h18"></path>
                      <path d="M6 3h12l3 4v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7l3-4z"></path>
                    </svg>
                  </span>
                  <span>${this.escapeHtml(item.title || '')}</span>
                </a>
              `)
              .join('')}
          </div>
        `;
      }

      if (pages.length || articles.length) {
        const contentItems = [...pages.slice(0, 2), ...articles.slice(0, 2)];

        html += `
          <div class="qn-search-group">
            <div style="padding: 10px 18px 6px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: #6b7280;">
              Contenido
            </div>
            ${contentItems
              .map((item) => `
                <a
                  href="${item.url || '#'}"
                  class="qn-search-item"
                  style="display:flex; align-items:center; gap:12px; padding:10px 18px; text-decoration:none; color:#1f2937;"
                >
                  <span style="display:inline-flex; width:18px; height:18px; align-items:center; justify-content:center; color:#6b7280;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <path d="M14 2v6h6"></path>
                    </svg>
                  </span>
                  <span>${this.escapeHtml(item.title || '')}</span>
                </a>
              `)
              .join('')}
          </div>
        `;
      }

      html += `
        <div style="padding: 10px 18px 4px;">
          <button
            type="submit"
            class="qn-search-view-all"
            style="width:100%; min-height:44px; border:none; border-radius:999px; background:#2d5a3d; color:#fff; font-weight:700; cursor:pointer;"
          >
            Ver todos los resultados
          </button>
        </div>
      `;

      html += `</div>`;

      this.searchResults.innerHTML = html;
      this.openSearch();
    },

    formatMoney(amount) {
      const value = parseFloat(amount);
      if (Number.isNaN(value)) return '';

      return new Intl.NumberFormat('es-UY', {
        style: 'currency',
        currency: 'UYU',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    },

    escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },

    openSearch() {
      if (this.searchResults) {
        this.searchResults.classList.add('active');
      }
    },

    closeSearch() {
      if (this.searchResults) {
        this.searchResults.classList.remove('active');
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => QNHeader.init());
  } else {
    QNHeader.init();
  }

  window.QNHeader = QNHeader;
})();